// import image from '../image/logo.png';
import {useState } from 'react';
import Mainmenu from './MainMenu';
import bot from '../../assets/images/happy.png';
import Frame1 from './Frame1';
// import Frame1 from './Frame1';
// import Loading from './Loading';

function Greetings(){
    const [time] = useState(new Date());


    const getGreeting = () => {
        const hours = time.getHours();
        if (hours < 12) return "Good Morning";
        if (hours < 18) return "Good Afternoon";
        return "Good Evening";
      };
     
    return(
        <>
        <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
            <div className="frame1 animated-frame">
           {getGreeting()}, Greetings from Akaay University<br/>
            </div>
            <div className="frame1 animated-frame">
   empowering minds, shaping futures.
  Discover innovation, excellence, and opportunity in every step.

  Your education, our mission — excellence in every experience.
</div>
            
              
            
            <Frame1 />
            {/* <Mainmenu /> */}
        </>
    );
}

export default Greetings;